import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_intersect = _resolveDirective("intersect")!

  return (_openBlock(), _createElementBlock("div", {
    id: "default-layout",
    style: $setup.style
  }, [
    _createVNode(_component_v_card, {
      width: "400",
      class: "mx-auto px-10 py-8",
      elevation: "2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_img, {
          src: $setup.logo,
          alt: "Maropost logo",
          height: "60"
        }, null, 8 /* PROPS */, ["src"]),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "my-6" }, [
          _createElementVNode("h4", { class: "font-weight-large" }, "To continue, Choose an account")
        ], -1 /* CACHED */)),
        _createVNode(_component_v_form, {
          modelValue: $setup.isFormValid,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.isFormValid) = $event)),
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_autocomplete, _mergeProps({
              ref: "autocompleteRef",
              search: $setup.search,
              "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => (($setup.search) = $event)),
              modelValue: $setup.model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.model) = $event)),
              items: $setup.items,
              label: "Select an account",
              "item-value": "id",
              "item-title": "name",
              "append-outer-icon": $setup.isLoading ? 'mdi-loading' : '',
              loading: $setup.isLoading,
              "no-data-text": 'No record found'
            }, _ctx.$attrs, {
              rules: [$setup.required('Account')],
              "return-object": "",
              "onUpdate:focused": $setup.onFocusHandler,
              "onUpdate:search": $setup.debouncedSearchHandler,
              "onUpdate:modelValue": $setup.onModelUpdate
            }), {
              "prepend-item": _withCtx(() => [
                ($setup.isLoading)
                  ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("Loading...", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              "append-item": _withCtx(() => [
                ($setup.isLoadMoreEnabled)
                  ? _withDirectives((_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("Loading more...", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })), [
                      [_directive_intersect, $setup.onIntersect]
                    ])
                  : _createCommentVNode("v-if", true)
              ]),
              item: _withCtx(({ props, item }) => [
                _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                  prepend: _withCtx(() => [
                    (item.raw.id === $setup.accountId)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          size: "24",
                          class: "mr-2",
                          style: {"color":"#f44336 !important"}
                        }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode(" mdi-alert-circle-outline ", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
              ]),
              _: 1 /* STABLE */
            }, 16 /* FULL_PROPS */, ["search", "modelValue", "items", "append-outer-icon", "loading", "rules", "onUpdate:search"]),
            _createVNode(_component_v_btn, {
              variant: $setup.isFormValid ? 'flat' : 'outlined',
              density: "default",
              class: "text-body-2 text-uppercase mt-1 font-weight-bold w-100",
              "base-color": "black",
              disabled: !$setup.isFormValid,
              onClick: $setup.onSubmitHandler
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" Submit ", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["variant", "disabled"]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "body-2 pt-4 text-medium-emphasis" }, [
              _createTextVNode("If the problem still persists "),
              _createElementVNode("a", {
                href: "mailto:support@maropost.com?subject=Support",
                target: "_blank"
              }, "Contact Support")
            ], -1 /* CACHED */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}